import React from 'react';

export const Disclaimer = (props) => {
    return  <p className="normalText"><b>DISCLAIMER</b>: The information provided by this instrument <u>IS NOT SUFFICIENT BY ITSELF</u> to predict the success of any given new business. Instead, it 
    is designed to add to the store of information available most preferably <i>before</i> the venture is started, or even if the venture is <i>already underway</i>, with the intention that the chances of success will be improved.</p>
}